import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import logo from '../logo2.png';

const Navbar = () => {
  const navigate = useNavigate();
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  const [open, setOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('role');
    navigate('/');
  };

  return (
    <nav className="sticky top-0 z-50 flex justify-between items-center px-6 py-4 shadow-md bg-white/5 backdrop-blur-md text-white border-b border-white/20">

      {/* Logo */}
      <Link to="/" className="flex items-center space-x-2">
        <img
          src={logo}
          alt="NeoMegaOne Logo"
          className="h-8 w-auto rounded-full hover:opacity-80 transition"
        />
        <span className="text-xl font-semibold text-[#1E90FF]">NeoMegaOne</span>
      </Link>

      {/* Desktop Menu */}
      <div className="hidden md:flex items-center space-x-4">
        <Link
          to="/aboutus"
          className="px-4 py-2 rounded font-semibold text-white transition bg-emerald-600 hover:bg-emerald-700 hover:opacity-90"
        >
          About Us
        </Link>

        <Link
          to="/pricing"
          className="px-4 py-2 rounded font-semibold text-white"
          style={{ backgroundColor: 'oklch(60% 0.25 300)' }}
        >
          Pricing
        </Link>

        {isAuthenticated ? (
          <button
            onClick={handleLogout}
            className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded transition"
            aria-label="Logout"
          >
            Logout
          </button>
        ) : (
          <Link
            to="/login"
            className="bg-[#1E90FF] hover:bg-blue-700 px-4 py-2 rounded transition"
            aria-label="Login"
          >
            Login
          </Link>
        )}

        {/* Desktop Resources Dropdown */}
        <div className="relative">
          <button
            onClick={() => setResourcesOpen(!resourcesOpen)}
            className="flex items-center px-3 py-2 rounded bg-white/10 hover:bg-white/20 transition"
          >
            <Menu className="h-5 w-5 mr-1" />
            <ChevronDown className="h-4 w-4" />
          </button>

          {resourcesOpen && (
            <div
              className="absolute right-0 mt-2 w-40 bg-white/10 backdrop-blur-md rounded shadow-lg border border-white/20 z-50"

            >
              <Link to="/careers" className="block px-4 py-2 text-white hover:bg-white/20">
                Careers
              </Link>
              <Link to="/resources/downloads" className="block px-4 py-2 text-white hover:bg-white/20">
                Downloads
              </Link>
              <Link to="/resources/blog" className="block px-4 py-2 text-white hover:bg-white/20">
                Blog
              </Link>
              <Link to="/resources/videos" className="block px-4 py-2 text-white hover:bg-white/20">
                Videos
              </Link>
              
              <Link to="/faqs" className="block px-4 py-2 text-white hover:bg-white/20">
                FAQs
              </Link>
            </div>
          )}
        </div>
      </div>

      {/* Mobile Toggle Button */}
      <button
        className="md:hidden"
        onClick={() => setOpen(!open)}
      >
        {open ? <X size={28} /> : <Menu size={28} />}
      </button>

      {/* Mobile Dropdown */}
      {open && (
        <div className="absolute top-16 right-0 bg-[#0B0F2F]/95 backdrop-blur-md py-6 shadow-lg border-l border-white/20 w-11/12 max-w-xs rounded-l-xl md:hidden">
          <ul className="flex flex-col items-center space-y-4">

            <li>
              <Link
                to="/aboutus"
                onClick={() => setOpen(false)}
                className="text-lg text-white hover:text-[#1E90FF]"
              >
                About Us
              </Link>
            </li>

            <li>
              <Link
                to="/pricing"
                onClick={() => setOpen(false)}
                className="text-lg text-white hover:text-[#1E90FF]"
              >
                Pricing
              </Link>
            </li>

            {/* Auth */}
            <li>
              {isAuthenticated ? (
                <button
                  onClick={() => { handleLogout(); setOpen(false); }}
                  className="text-lg text-white hover:text-[#1E90FF]"
                >
                  Logout
                </button>
              ) : (
                <Link
                  to="/login"
                  onClick={() => setOpen(false)}
                  className="text-lg text-white hover:text-[#1E90FF]"
                >
                  Login
                </Link>
              )}
            </li>

            {/* ⭐ Careers ABOVE Resources */}
            <li>
              <Link
                to="/careers"
                onClick={() => setOpen(false)}
                className="text-lg text-white hover:text-[#1E90FF]"
              >
                Careers
              </Link>
            </li>

            {/* ⭐ FAQs ABOVE Resources */}
            <li>
              <Link
                to="/faqs"
                onClick={() => setOpen(false)}
                className="text-lg text-white hover:text-[#1E90FF]"
              >
                FAQs
              </Link>
            </li>

            {/* Mobile Resources */}
            <li className="flex flex-col items-center w-full">
              <button
                onClick={() => setResourcesOpen(!resourcesOpen)}
                className="text-lg text-white hover:text-[#1E90FF] flex items-center space-x-1"
              >
                <span>Resources</span>
                <ChevronDown
                  className={`h-4 w-4 transition-transform ${resourcesOpen ? 'rotate-180' : ''}`}
                />
              </button>

              {resourcesOpen && (
                <ul className="flex flex-col items-center mt-2 space-y-2 w-full">

                  {/* ONLY these inside Resources now */}
                  <li>
                    <Link
                      to="/resources/downloads"
                      onClick={() => setOpen(false)}
                      className="text-white hover:text-[#1E90FF]"
                    >
                      Downloads
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/resources/blog"
                      onClick={() => setOpen(false)}
                      className="text-white hover:text-[#1E90FF]"
                    >
                      Blog
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/resources/videos"
                      onClick={() => setOpen(false)}
                      className="text-white hover:text-[#1E90FF]"
                    >
                      Videos
                    </Link>
                  </li>

                </ul>
              )}
            </li>

          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
